// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__V4okE","divider":"tabs_divider__fyR40","tabs":"tabs_tabs__IDDhy","tab":"tabs_tab__mHfJ0","count":"tabs_count__dH8Mq","active":"tabs_active__R0dQ8"};